<!--车牌键盘  -->
<template>
    <div class="keyBoard">
      <!-- 键盘标题 -->
      <div class="title_box">
        <span class="cancel" @click="cancel">取消</span>
        <p>添加车牌</p>
        <span :class="['sure',licenseNumber.length>=7?'sureDone':'']" @click="done">确认</span>
      </div>
      <!-- 车牌号 -->
      <div class="cardBox">
        <span :class="['card_item',(licenseNumber.length == item-1 || userSelect == item)?'curS':'']" v-for="item in 8" :key="item">
          {{licenseNumber[item-1]}}
          <img v-if="item==8" src="../../../assets/images/xny.png" />
          </span>
      </div>
      <!-- 城市简称 -->
      <div class="city_box" v-if="showCityKeyBoard">
        <div class="keyLine" v-for="(item,index) in keyBoardData" :key="index">
          <div class="keyItem" v-for="keyItem in item" :key="keyItem">
            <p class="keyItem_div" @click="getCarId(keyItem,1)">{{keyItem}}</p>
          </div>
        </div>
      </div>
      <!--数字拼音键盘  -->
      <div class="city_box" v-else>
        <div class="keyLine">
          <div v-for="item in keyBoardCountData1" :key="item" :class="['keyItem',numClick?'':'disabled']" @click="getCarId(item,numClick?'2':'3')">
            <p class="keyItem_div">{{item}}</p>
          </div>
        </div>
        <div class="keyLine">
          <div v-for="item in keyBoardCountData2" :key="item" class="keyItem" @click="getCarId(item,2)">
            <div class="keyItem_div">{{item}}</div>
          </div>
        </div>
        <div class="keyLine">
          <div v-for="item in keyBoardCountData3" :key="item" class="keyItem" @click="getCarId(item,2)">
            <div class="keyItem_div">{{item}}</div>
          </div>
        </div>
        <div class="keyLine">
          <div v-for="item in keyBoardCountData4" :key="item" class="keyItem" @click="getCarId(item,2)">
            <div class="keyItem_div">{{item}}</div>
          </div>
          <div v-for="item in keyBoardCountData5" :key="item" :class="['keyItem',textClick?'':'disabled']" @click="getCarId(item,textClick?'2':'3')">
            <div class="keyItem_div">{{item}}</div>
          </div>
          <div class="deleteKeyCount" @click="deleteKeyCount">
            <img class="deleteKeyCount_icon" src="../../../assets/images/icon_keyboard_clear.png"/>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import util from '../../../utils/util.js'
export default {
  name: 'keyBoard',
  props: {
    showPopup:{
      type: Boolean,
      default: false
    },
    cardIndex:{
      type:Number,
      default:0
    },
    cardNumber:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      licenseNumber:[],
      activeIndex:0,
      showCityKeyBoard:true,
      userSelect:0,//用户选中索引
      numClick:false,//数字是否可点
      textClick:false,//港澳台是否可点
      keyBoardData: [
        ['京', '沪', '粤', '津', '冀', '豫', '云', '辽', '黑', '湘'],
        ['皖', '鲁', '新', '苏', '浙', '赣', '鄂', '桂', '甘'],
        ['晋', '蒙', '陕', '吉', '闽', '贵', '渝', '川'],
        ['青', '藏', '琼', '宁', '使']
      ],
      keyBoardCountData1: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      keyBoardCountData2: ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'O', 'P', 'A'],
      keyBoardCountData3: ['S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Z', 'X'],
      keyBoardCountData4: ['C', 'V', 'B', 'N', 'M'],
      keyBoardCountData5: ['港', '澳', '学','领']
    };
  },
  watch:{
    cardIndex(){
      this.licenseNumber = !this.cardNumber?[]:this.cardNumber.split("")
      console.log(this.cardNumber)
      if(!this.cardNumber){
        this.showCityKeyBoard = true;
        this.numClick = false;
        this.textClick = false;
      }
    }
  },
  methods: {
    getCarId(val,type){
      if(type == 1){
        this.showCityKeyBoard = false
        this.licenseNumber[0] = val
      }else{
        if(type == 3 || this.licenseNumber.length === 8){
          return;
        }
        this.licenseNumber.push(val)
        if(this.licenseNumber.length >= 2){
          this.numClick = true;
          if(this.licenseNumber.length >= 6){
            this.textClick = true;
          }
        }
      }
    },
    done() {
      if(this.licenseNumber.length < 7){return;}
      let val = this.licenseNumber.join('');
      if (!util.isLicensePlate(val)) {
        util.showToast("请输入合法车牌号");
        return
      }
      this.$emit('sure',val)
    },
    cancel() {
      this.$emit('close')
    },
    deleteKeyCount(){
      if(this.licenseNumber.length === 1){
        this.showCityKeyBoard = true;
        this.licenseNumber.length = 0;
        this.numClick = false;
        this.textClick = false;
      }else if(this.licenseNumber.length === 2){
        this.numClick = false;
        this.textClick = false;
      }else if(this.licenseNumber.length === 6){
        this.textClick = false;
      }
      this.licenseNumber.pop()
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
// 标题
.title_box{
  .flex();
  height:100px;
  align-items: center;
  background:#fff;
  .cancel{
    font-size:30px;
    color:rgba(51,51,51,1);
    padding:0 100px 0 28px;
    height:100px;
    line-height: 100px;
  }
  p{
    font-size:34px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    flex:1;
    text-align:center;
    height:100px;
    line-height: 100px;
  }
  .sure{
    font-size:30px;
    color:#666;
    padding:0 28px 0 100px;
    height:100px;
    line-height: 100px;
  }
  .sureDone{
    color:rgba(23,64,218,1);
  }
}
// 车牌号
.cardBox{
  .flex();
  justify-content: center;
  padding:60px 0;
  background:#fff;
  .card_item{
    width:76px;
    height:88px;
    line-height:88px;
    border-radius:4px;
    .border();
    text-align:center;
    margin:0 5px;
    position:relative;
    font-size:34px;
    font-weight: bold;
    &:last-child{
      background:rgba(243,251,249,1);
      .border(rgba(198,238,225,1));
    }
    img{
      display:block;
      width:80px;
      height:30px;
      position:absolute;
      top:-18px;
      left:50%;
      transform: translate(-50%);
    }
  }
  .curS{
    .border(rgba(23,64,218,1));
    &:last-child{
      .border(rgba(23,64,218,1));
    }
  }
}
// 城市简称
.city_box{
  width: 100%;
  padding:8px 0;
  .keyLine {
    .flex();
    justify-content: center;
    .keyItem {
      margin: 12px 6px;
      box-shadow:0px 2px 2px 0px rgba(4,4,15,0.36);
      border-radius: 6px;
      background-color: #ffffff;
      .keyItem_div {
        width: 62px;
        height: 84px;
        border-radius: 6px;
        line-height: 84px;
        text-align: center;
        color: #000;
        font-size: 36px;
        &:active{
          background:#eee;
        }
        &:visited,&:link{
          background:#fff;
        }
      }
    }
    .disabled{
      background:#eee;
    }
  }

}
// 数字字母键盘
.keyBoardCount{
  width: 100%;
  padding:8px 0;
}
.keyBoard{
  width: 100%;
  background:#D6D9DE;
  .keyCountLine1 {
    height: 84px;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .keyCountLine {
    height: 84px;
    width: 750px;
    margin-top: 24px;
    display: flex;
    justify-content: center;
    flex-direction: row;
  }

  .keyCountLineItem {
    width: 62px;
    height: 84px;
    border-radius: 10px;
    background-color: #FEFEFE;
    box-shadow:0px 2px 2px 0px rgba(4,4,15,0.36);
    margin: 0 6px;
  }

  .keyCountLineItem_div {
    font-size: 42px;
    height: 84px;
    line-height: 84px;
    text-align: center;
    color: #000000;
    border-radius: 10px;
  }
  .deleteKeyCount {
    width: 62px;
    height: 84px;
    border-radius: 10px;
    margin: 12px 6px;
    .flex();
    justify-content: center;
    align-items: center;
    background-color: #C9C9C9;
    box-shadow:0px 2px 2px 0px rgba(4,4,15,0.36);
    .deleteKeyCount_icon {
      width: 44px;
      height: 32px;
    }
  }

  .done {
    width: 174px;
    height: 84px;
    border-radius: 10px;
    background-color: #C9C9C9;
    box-shadow:0px 2px 2px 0px rgba(4,4,15,0.36);
    margin: 0 6px 0 10px;
  }
}
</style>
